// extracted by mini-css-extract-plugin
export default {"inputContainer":"input_inputContainer__4Kj5K","inputBox":"input_inputBox__mjJFf","fileInput":"input_fileInput__sr6Sn","editInput":"input_editInput__jSirs"};